import { AstraDialog, AstraHeading, AstraParagraph } from '~/astra'

import { releaseNotes } from './releaseNote'

type Props = {
    onClose: () => void
}

export const ReleaseNotesDialog = ({ onClose }: Props) => (
    <AstraDialog
        isOpen={true}
        onCloseDialog={onClose}
        title="Endringslogg"
        align="top"
        className="w-[min(40rem,calc(100vw-2rem))]"
        data-test="release-note-dialog"
        header={
            <div className="flex min-w-0 flex-1 items-center gap-2">
                <AstraHeading as="h3" className="min-w-0 truncate">
                    Endringslogg
                </AstraHeading>
            </div>
        }
    >
        <div className="flex flex-col gap-6 py-2">
            {releaseNotes.toReversed().map(releaseNote => (
                <div key={releaseNote.id} className="flex flex-col gap-1">
                    <AstraParagraph weight="medium">{releaseNote.title}</AstraParagraph>
                    <AstraParagraph className="text-subtle">{releaseNote.description}</AstraParagraph>
                </div>
            ))}
        </div>
    </AstraDialog>
)
